import Vue from 'vue'
import { Slide } from 'vue-carousel'
import TopNavTrigger from '../../components/core/TopNavTrigger'
import Carousel from '../../components/core/Carousel'
import DownloadGuide from '../../views/downloadGuide/DownloadGuide'
import initMobileGallery from '../common/initMobileGallery'
import Responsive from '../../components/core/Responsive'
import SearchParamsDesktop from '../../components/Search/SearchParamsDesktop'
import CountriesTab from '../../components/Country/CountriesTab'
import CountryCTA from '../../components/Country/CountryCTA'
import SpeakWithUs from '../../components/Country/SpeakWithUs'
import DestinationCTA from '../../components/Country/DestinationCTA'
import FeaturedReview from '../../components/FeaturedReview'
import CurrencyContext from '../../components/core/CurrencyContext'

$(document).ready(function() {
  initMobileGallery()

  const stickyHeader = $('.country-secondary-nav')
  const footerNav = $('.country-footer-nav')

  stickyHeader.stickySidebar({
    topSpacing: 0,
    bottomSpacing: 50,
    containerSelector: '.sticky-nav-container',
    innerWrapperSelector: '.sidebar__inner'
  })

  const isMobile = window.matchMedia('only screen and (max-width: 1200px)').matches

  if (isMobile) {
    stickyHeader.get(0).addEventListener('affixed.top.stickySidebar', function () {
      pushUpTrengoChat(true)
      footerNav.removeClass('is-hidden')
    })

    stickyHeader.get(0).addEventListener('affixed.container-bottom.stickySidebar', function () {
      pushUpTrengoChat(false)
      footerNav.addClass('is-hidden')
    })

    stickyHeader.get(0).addEventListener('affixed.static.stickySidebar', function () {
      pushUpTrengoChat(false)
      footerNav.addClass('is-hidden')
    })
  }

  if ($('#country-sticky-nav').length) {
    setTimeout(() => {
      $('#country-sticky-nav').navpoints({
        offset: 200
      })
    }, 2000)
  }

  const overviewParagraph = $('.country-overview-text.collapsible');
  if (overviewParagraph.length && isMobile) {
    const ps = overviewParagraph.find('p');

    if (ps.length > 1) {
      const wrapper = $('<div class="overview-text-extra hidden">');
      for (let i = 1; i < ps.length; ++i) {
        wrapper.append(ps[i]);
      }
      wrapper.appendTo(overviewParagraph);

      const readMore = $('.read-more-button');
      readMore.on('click', function () {
        if (wrapper.hasClass('hidden')) {
          wrapper.removeClass('hidden');
          readMore.find('span').text('Read less');
          readMore.find('svg use').attr('xlink:href', '/img/sprite.svg#ic_chevron-up');
        }
        else {
          wrapper.addClass('hidden');
          readMore.find('span').text('Read more');
          readMore.find('svg use').attr('xlink:href', '/img/sprite.svg#ic_chevron-down');
          window.scrollToElement(readMore[0]);
        }
      });
    }
  }
})

Vue.component('top-nav-trigger', TopNavTrigger)
Vue.component('carousel', Carousel)
Vue.component('v-slide', Slide)
Vue.component('download-guide', DownloadGuide)
Vue.component('responsive', Responsive)
Vue.component('search-params-desktop', SearchParamsDesktop)
Vue.component('countries-tab', CountriesTab)
Vue.component('country-cta', CountryCTA)
Vue.component('speak-with-us', SpeakWithUs)
Vue.component('destination-cta', DestinationCTA)
Vue.component('featured-review', FeaturedReview)
Vue.component('currency-context', CurrencyContext)

const apps = document.querySelectorAll('.vue-app')

Array.prototype.forEach.call(apps, el => new Vue({
  el,
  template: el.innerHTML
}))
